import {
	COMPANY_SAVED,
	COMPANY_SAVING,
	COMPANY_SAVING_FAILED,
	COMPANY_SAVING_INITIALIZE,
} from "../actions/types";
const initialState = {
	isSaving: false,
	isSaved: false,
	isFailed: false,
	company: {},
};
export default function (state = initialState, action) {
	switch (action.type) {
		case COMPANY_SAVING:
			return {
				...state,
				isSaving: true,
				isSaved: false,
				isFailed: false,
				company: {},
			};
		case COMPANY_SAVED:
			return {
				...state,
				isSaving: false,
				isSaved: true,
				isFailed: false,
				company: action.payload,
			};
		case COMPANY_SAVING_INITIALIZE:
			return {
				...state,
				isSaving: false,
				isSaved: false,
				isFailed: false,
				company: {},
			};

		case COMPANY_SAVING_FAILED:
			return {
				...state,
				isSaving: false,
				isSaved: false,
				isFailed: false,
				company: {},
			};

		default:
			return state;
	}
}
